//main
import App from "./App";
import React from "react";
//styles
import "./styles/index.css";
//react
import ReactDOM from "react-dom";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
